import { Box, Grid, Typography } from '@mui/material';
import React, { FC, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ModalName, Route } from 'app/enums';
import { modalsReducers } from 'app/store/modal/slice';
import { ControlItem } from '../ControlItem/ControlItem';
import trophyIcon from 'assets/images/trophy.svg';
import controllerIcon from 'assets/images/controller.svg';
import swordsIcon from 'assets/images/swords.svg';
import medalIcon from 'assets/images/medal.svg';
import { useStyles } from './Controls.styles';

export const Controls: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { classes } = useStyles();

  const createMatch = useCallback(() => {
    dispatch(modalsReducers.openModal({ name: ModalName.CreateMatch }));
  }, [dispatch]);

  const createTournament = useCallback(() => {
    navigate(Route.CreateTournament);
  }, [navigate]);

  const items = useMemo(() => {
    return [
      {
        title: 'Create a Tournament',
        description:
          'Want to make money with OKLP or simply organize a tournament? Do it with our custom creation system.',
        action: createTournament,
        disabled: false,
        icon: trophyIcon,
        actionTitle: 'Create',
      },
      {
        title: 'Create a PVP Match',
        description:
          'Customize your own match and challenge friends and fellow OKLP members in a one-time contest.',
        action: createMatch,
        disabled: false,
        icon: swordsIcon,
        actionTitle: 'Create',
      },
      {
        title: 'Join a Match',
        description:
          'Browse the open matches or play a few of our free games to practice for your next competitive game.',
        action: () => {},
        disabled: true,
        icon: controllerIcon,
        actionTitle: 'View All',
      },
      {
        title: 'Join a Tournament',
        description:
          'Ready to get the competition going? Join one of our many tournaments starting soon.',
        action: () => {},
        disabled: true,
        icon: medalIcon,
        actionTitle: 'View All',
      },
    ];
  }, [createTournament, createMatch]);

  return (
    <Box>
      <Typography variant="h3">Play Your Way</Typography>
      <Grid container spacing={3} className={classes.root}>
        {items.map((item) => (
          <Grid item key={item.title} data-testid="match-tile">
            <ControlItem item={item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
